// extracted by mini-css-extract-plugin
export default {"button":"BackButton_button__mgOAZ","icon":"BackButton_icon__GQX9u"};